import { ACCOUNT_CASE_METRICS } from "@/components/accounts/account-case-metrics";

export const MERCURY_DEFAULT_ACCOUNT_VISIBLE_COLUMNS = [
  "name",
  "accountRisks",
  ACCOUNT_CASE_METRICS.treasuryChurn.columnId,
  ACCOUNT_CASE_METRICS.urgency.columnId,
  ACCOUNT_CASE_METRICS.treasuryChurnScore.columnId,
  "cf:Relationship_Manager_Text__c",
  "cf:Organization_Status__c",
  "cf:Account_Balance__c",
  "cf:Linked_Balance__c",
  "cf:Treasury_Application_Status__c",
  "cf:Treasury_Balance__c",
  "cf:Date_Eligible_for_Treasury__c",
  "cf:Cumulative_IO_Spend__c",
  "cf:Cumulative_Competitor_Card_Spend__c",
  "cf:L30_Day_Revenue__c",
  "cf:L90D_Gross_Profit__c",
  "cf:L30D_Gross_Revenue__c",
  "cf:Average_Checking_Balance_30d__c",
  "cf:Average_Treasury_Balance_30d__c",
  "cf:Average_Savings_Balance_30d__c",
  "cf:Current_Balance_Bucket__c",
  "cf:Max_Deposits__c",
] as const;
